module.exports = __webpack_public_path__ + "img/leprechaun_dancing.5dc880ee.jpg";